const pricePerCan = class extends HTMLElement {
  constructor() {
    super()

    this.fieldset = document.querySelector('[data-product-selling-plan-fieldset]')
    this.quantity = Number(this.dataset.quantity || 0)
    this.unitsPer = Number(this.dataset.unitsPer)
    this.discountAmount = Number(this.dataset.discountAmount || 0)
    this.text = this.dataset.text
  }

  connectedCallback () {
    if (this.quantity === 0 || this.unitsPer === 0) {
      this.classList.add('hidden')
      return
    }

    this.fieldset.addEventListener('change', () => {
      this.updatePrice()
    })

    this.updatePrice()
  }

  updatePrice () {
    const selectedPlan = this.fieldset.querySelector('input[type="radio"]:checked')
    const price = Number(selectedPlan.dataset.price)
    const pricePerCan = ((price * this.quantity) - this.discountAmount) / this.unitsPer
    this.innerText = this.text.replace('$', this.numberToMoney(pricePerCan))
  }

  numberToMoney (price) {
    return `$${(price * 0.01).toFixed(2)}`
  }
}

if (typeof window.customElements.get('price-per-can') === 'undefined') {
  window.customElements.define('price-per-can', pricePerCan)
}
